import styled from "styled-components"

const CenterTransform = styled.div`
  transform: translate(0, 25%);
  text-align: left;
`

export const TagModalList = styled.div`
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
`

export const CenteredTag = styled.div`
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: -20px;
`
export default CenterTransform
